var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_6467)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 32,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4092 1.15894H2.58462C1.61354 1.15894 0.821045 2.01927 0.821045 3.08705V29.739C0.821045 30.8007 1.60796 31.6671 2.58462 31.6671H43.4148C44.3858 31.6671 45.1783 30.8068 45.1783 29.739V3.08705C45.1728 2.02537 44.3858 1.15894 43.4092 1.15894Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1952 11.3208C29.7764 10.1382 28.5764 9.40079 27.3246 9.39151H26.1388C26.0164 9.04369 25.8941 8.7005 25.767 8.35267C24.9717 6.18688 21.8941 5.81586 20.4494 7.55963C20.0258 8.06978 19.8423 8.77007 19.6258 9.39151C19.2305 9.39151 18.8305 9.39151 18.4352 9.39151C17.1835 9.40079 15.9835 10.1428 15.5694 11.3208C15.1552 12.4848 15.6352 13.737 16.647 14.428C16.967 14.6414 17.287 14.8547 17.607 15.068C17.4846 15.4112 17.3623 15.759 17.2399 16.0976C16.8399 17.2663 17.3388 18.5138 18.3599 19.1956C19.4141 19.9005 20.8541 19.9098 21.9176 19.2141C22.2376 19.0008 22.5576 18.7921 22.8776 18.5788C23.1929 18.7921 23.5129 19.0008 23.8376 19.2141C24.9011 19.9098 26.3411 19.9005 27.3952 19.1956C28.4211 18.5138 28.9152 17.2709 28.5152 16.0976L28.1482 15.068C28.4682 14.8547 28.7882 14.6414 29.1082 14.4234C30.1294 13.7417 30.6094 12.4895 30.1952 11.3208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.607 13.5191C27.9976 13.2594 28.4211 13.0368 28.5858 12.573C28.8917 11.729 28.1623 10.9498 27.3105 10.9406C25.334 10.9406 23.3576 10.9359 21.3811 10.9359C21.5129 10.5742 21.6446 10.2078 21.7717 9.84607H27.3246C28.3693 9.85534 29.3764 10.4675 29.7246 11.46C30.0682 12.4339 29.6682 13.482 28.8164 14.0617C28.5388 14.2472 28.2658 14.4281 27.9882 14.609C27.8658 14.2519 27.734 13.8855 27.607 13.5191Z",
    fill: "#EAB649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3224 17.6187C24.6094 17.8135 24.8965 18.0361 25.24 18.1335C26.1953 18.3979 27.2447 17.5631 26.9059 16.566L25.0706 11.4042L26.3271 11.3996C26.9012 13.0135 27.4706 14.6274 28.0447 16.2367C28.3789 17.2153 27.9647 18.2634 27.1083 18.8292C26.2236 19.4228 25.0141 19.4228 24.1247 18.8431C23.8518 18.6576 23.5788 18.4767 23.3059 18.2912C23.6447 18.0732 23.9836 17.846 24.3224 17.6187Z",
    fill: "#EAB649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0519 16.0281C18.9013 16.4547 18.7084 16.8628 18.8637 17.322C19.1508 18.1521 20.2237 18.4257 20.9437 17.9573L25.7296 14.7666L26.1249 15.8565C24.6284 16.8536 23.1319 17.8507 21.6355 18.8478C20.9625 19.2883 20.1249 19.3811 19.3813 19.1678C18.6425 18.9544 17.9978 18.4396 17.7249 17.6605C17.4378 16.8396 17.7625 16.1208 18.0355 15.3556C18.3743 15.5782 18.7131 15.8008 19.0519 16.0281Z",
    fill: "#EAB649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0753 10.9405C18.5906 10.9359 18.1059 10.8942 17.6776 11.1724C16.9388 11.6594 16.9341 12.6843 17.6635 13.1805L22.4588 16.3713C22.12 16.5985 21.7812 16.8257 21.4423 17.053C19.9459 16.0559 18.4494 15.0588 16.9529 14.0663C15.5741 13.1342 15.5882 11.2095 16.9765 10.2913C17.7388 9.78575 18.5953 9.85067 19.4659 9.85067C19.3341 10.2124 19.2071 10.5788 19.0753 10.9405Z",
    fill: "#EAB649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.36 9.39152C24.2988 9.21529 24.2329 9.03442 24.1717 8.85355C23.7529 7.73587 22.0117 7.7266 21.5976 8.85355C20.9859 10.5788 20.3835 12.2993 19.7717 14.0199C19.4282 13.7973 19.0894 13.5701 18.7458 13.3428C19.32 11.7336 19.8894 10.1196 20.4588 8.50573C21.127 6.68776 23.7106 6.37239 24.9153 7.8379C25.2682 8.26457 25.4282 8.86747 25.6117 9.39152H24.36Z",
    fill: "#EAB649"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8096 12.8187C27.6873 12.9022 27.5649 12.9857 27.4378 13.0645L26.8496 11.395C27.1743 11.395 27.5178 11.3579 27.8002 11.548C28.2661 11.8587 28.2708 12.5034 27.8096 12.8187Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1155 17.577C25.819 17.7718 25.4143 17.7764 25.1179 17.5816C24.9955 17.5028 24.8732 17.4193 24.7461 17.3358C25.2637 16.9927 25.7767 16.6495 26.2943 16.3063C26.3414 16.4408 26.3932 16.5706 26.4402 16.7051C26.5437 17.039 26.4026 17.3869 26.1155 17.577Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.654 17.5771C19.367 17.3869 19.2258 17.0345 19.3387 16.7098L19.4799 16.311L21.0234 17.3405C20.9011 17.424 20.7787 17.5075 20.6517 17.5863C20.3505 17.7765 19.9505 17.7765 19.654 17.5771Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6541 11.9423C17.7717 11.613 18.1106 11.3997 18.4588 11.395H18.9153C18.7176 11.9515 18.52 12.5081 18.3223 13.0646C18.2 12.9811 18.0776 12.8976 17.9506 12.8188C17.6682 12.624 17.5365 12.2715 17.6541 11.9423Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2213 11.3996H24.5483L25.5789 14.3028L22.8871 16.0976C21.9883 15.5039 21.0942 14.9057 20.1907 14.3074C20.5342 13.3381 20.8777 12.3689 21.2213 11.3996Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8869 8.45471C23.2352 8.45471 23.574 8.65877 23.6963 8.98805C23.7434 9.12254 23.7905 9.25239 23.8375 9.38689H21.9316C21.9787 9.25239 22.0258 9.12254 22.0728 8.98805C22.1952 8.65877 22.534 8.45471 22.8869 8.45471Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39305 21.6211H7.69657L6.68952 26.3933H5.38599L6.39305 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.51991 21.6211H10.134L11.127 24.9278H11.1411L11.8187 21.6211H13.0423L12.0117 26.3933H10.407L9.3905 23.0912H9.37638L8.70344 26.3933H7.48462L8.51991 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4072 22.5625H13.1978L13.4048 21.6211H17.1319L16.9248 22.5625H15.7154L14.8919 26.3886H13.5789L14.4072 22.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3859 21.6211H20.7929L20.6047 22.5208H18.4776L18.2565 23.5086H20.2706L20.0729 24.4083H18.0588L17.8235 25.4889H20.0353L19.8518 26.3933H16.3506L17.3859 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2164 21.6211H22.7646C23.6869 21.6257 24.7975 21.6536 24.7975 22.8362C24.7975 23.6756 24.134 23.9724 23.3905 24.0605V24.0744C23.7716 24.1115 23.894 24.617 23.9646 24.9231L24.3128 26.3933H23.0234L22.774 25.1782C22.6469 24.5567 22.6093 24.5057 22.0258 24.5057H21.8893L21.5034 26.3933H20.2046L21.2164 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0681 23.6014H22.5058C23.0658 23.6014 23.5034 23.4669 23.5034 23.0124C23.5034 22.6739 23.2964 22.5255 22.9058 22.5208H22.2893L22.0681 23.6014Z",
    fill: "#0071BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6919 21.6211H27.0001L26.1954 25.4472H28.2236L28.0213 26.3933H24.6848L25.6919 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4612 21.6211H30.7647L29.7576 26.3933H28.4541L29.4612 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4659 21.6211H33.08L34.0729 24.9278H34.0871L34.7647 21.6211H35.9882L34.9624 26.3933H33.353L32.3412 23.0912H32.3271L31.6541 26.3933H30.4353L31.4659 21.6211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7223 21.6211H38.0259L37.6071 23.5689H37.6212L39.3718 21.6211H41.0423L38.7412 23.9399L40.1671 26.3933H38.68L37.4847 24.2228H37.4706L37.0047 26.3933H35.7012L36.7223 21.6211Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#ECEDF3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterlink);
export default __webpack_public_path__ + "static/media/interlink.74ff399d5fc5f2063a1eca3e1aa1f33f.svg";
export { ForwardRef as ReactComponent };